
<nav class="navbar navbar-expand-lg sticky-top top-bar" *ngIf="currentItem">
  <div class="container-fluid">


    <a class="navbar-brand" [routerLink]="['/']">
      <img [src]="getClientLogo(currentItem??null)" class="bussinesLogo d-lg-inline-block" *ngIf="currentItem" />
      <h3>{{currentItem?.BusinessName }}</h3>
    </a>
    <div class="offcanvas" tabindex="-1" id="clientNavbar" aria-labelledby="clientNavbarLabel">
      <div class="offcanvas-body">
        <ul class="navbar-nav flex-grow-1 pe-3">
          <li class="nav-item">
            <a class="nav-link " href="javascript:void()" (click)="clickItem('')">
              General Settings
            </a>
          </li>

          <li class="nav-item">
            <a class="nav-link " href="javascript:void()" (click)="clickItem('Users')">
              Client Users
            </a>
          </li>

          <li class="nav-item">
            <a class="nav-link " href="javascript:void()" (click)="clickItem('Permissions')">
              Manage Permissions
            </a>
          </li>

          <li class="nav-item">
            <a class="nav-link " href="javascript:void()" (click)="clickItem('Features')">
              Manage Features
            </a>
          </li>

        </ul>
      </div>
    </div>
  </div>
</nav>
